export default __webpack_public_path__ + "static/media/air-balloon-shadow.fa1fff6c.svg";